import { API, createJsonHeaders } from "app/api";
import {
  API_BASE_URL,
  LOGIN,
  SIGN_UP,
  ACTIVATION,
  RESET,
  LOGOUT,
  USER_INFO,
  RESET_FORM
} from "./constants";

export const resetForm = () => ({
  type: RESET_FORM
});

export const login = params => {
  const { email, password } = params;
  const url = `${API_BASE_URL}/auth/login`;
  const body = JSON.stringify({ username: email, password });
  const headers = createJsonHeaders(body);
  const request = new Request(url, {
    method: "POST",
    credentials: "same-origin",
    headers,
    body
  });
  return {
    type: API,
    payload: {
      request,
      ...LOGIN
    }
  };
};

export const signUp = params => {
  const { email, fullName, password, screenName } = params;
  const url = `${API_BASE_URL}/auth/signup`;
  const body = JSON.stringify({ email, fullName, password, screenName });
  const headers = createJsonHeaders(body);
  const request = new Request(url, {
    method: "POST",
    credentials: "same-origin",
    headers,
    body
  });
  return {
    type: API,
    payload: {
      request,
      ...SIGN_UP
    }
  };
};

export const activate = params => {
  const { token } = params;
  const url = `${API_BASE_URL}/activate/${token}`;
  const headers = createJsonHeaders();
  const request = new Request(url, {
    method: "GET",
    credentials: "same-origin",
    headers
  });
  return {
    type: API,
    payload: {
      request,
      ...ACTIVATION
    }
  };
};

export const reset = params => {
  const { email } = params;
  const url = `${API_BASE_URL}/reset`;
  const body = JSON.stringify({ email });
  const headers = createJsonHeaders(body);
  const request = new Request(url, {
    method: "POST",
    credentials: "same-origin",
    headers,
    body
  });
  return {
    type: API,
    payload: {
      request,
      ...RESET
    }
  };
};

export const logout = () => {
  return {
    type: LOGOUT
  };
};

export const fetchUserInfo = params => {
  const url = `${API_BASE_URL}/users/${params.userId}/info`;
  const request = new Request(url, {
    method: "GET",
    credentials: "same-origin"
  });
  return {
    type: API,
    payload: {
      request,
      params,
      ...USER_INFO
    }
  };
};



// WEBPACK FOOTER //
// ./src/app/auth/actions.js